export default function getLocaleContent(companyName, companyDetails) {
  return companyDetails[companyName] || companyDetails.default;
}
